module.exports = __webpack_public_path__ + "media/images/flags/32/Macau-67133a2e75f2a21a37bdfd61e8f4e663.png";